import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-vh-sale-stats',
  templateUrl: './vh-sale-stats.component.html',
  styleUrls: ['./vh-sale-stats.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VhSaleStatsComponent {

}
